mediator = require 'mediator'
{ useI18n, useCoffeeCallback } = require 'lib/react_utils'
sectionLinksExtension = require './editor_extensions/section_links/section_links'
ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
DocumentSectionsV2Store = require 'stores/document_sections_v2_store'
DocumentSectionsV2Actions = require 'actions/document_sections_v2_actions'
ConnectStore = require 'components/enhancers/connect_store'
Modal = require 'components/common/modal'

{
  default: Editor
} = Epiditor

storeConnector =
  DocumentSectionsV2Store: (Store) ->
    restoreModalState: Store.getRestoreModalState()


# What is the maximum number of revisions difference to allow restoring
# (to prevent restoring very old revisions by mistake)
REVISION_THRESHOLD = 5

EditorErrorBoundaryFallback = ({ sectionData, restoreModalState }) ->

  i18n = useI18n("docsec:editor")

  currentRev = parseInt(sectionData._rev.split('-')[0] or 0)
  techRev = parseInt(sectionData.tech_old_rev?._rev?.split('-')[0] or 0)
  techRevTimestamp = sectionData.tech_old_rev?.$timestamp
  contentForPreview = sectionData.tech_old_rev?.content ? ""

  mightBePossibleToRestore = currentRev - techRev <= REVISION_THRESHOLD and mediator.user.isAdmin() and contentForPreview isnt ""

  onRestore = useCoffeeCallback [sectionData, contentForPreview], ->
    DocumentSectionsV2Actions.restoreSectionContent({
      sectionId: sectionData._id,
      content: contentForPreview
    })

  <div className="editor-error-boundary-fallback">
    <h3>{i18n('section_display_error')}</h3>
    {if mightBePossibleToRestore
      <div>
        <p>
          {i18n('try_to_restore_last_known_good_state')}
        </p>
        <button
          className="restore-button"
          onClick={DocumentSectionsV2Actions.openRestoreModal}
        >
          {i18n('/actions.restore')}
        </button>
        <Modal
          className="mdg-topics-field-modal"
          isOpen={restoreModalState.get('isOpen', false)}
          modalSize="full"
          closeButton
          onClose={DocumentSectionsV2Actions.closeRestoreModal}
          title={i18n 'restore_section_content'}
        >
          <div><strong>{i18n('last_good_version')}</strong>: {moment(techRevTimestamp)?.format(i18n('/time_format'))}</div>
          <div><strong>{i18n('sectionId')}</strong>: {sectionData._id}</div>
          <div className="editor-error-boundary-fallback">
            <Editor
              extensions={[
                sectionLinksExtension(),
              ]}
              initialState={contentForPreview}
              mode="readonly"
              onChange={_.noop}
              onClick={_.noop}
              onLoad={_.noop}
              pluginProps={{}}
            />
          </div>
          <ApplyCancelButtons
            applyLabel={i18n('/actions.restore')}
            onApply={onRestore}
            onCancel={DocumentSectionsV2Actions.closeRestoreModal}
            applying={restoreModalState.get('loading', false)}
          />
        </Modal>
      </div>
    else
      <p>
        {i18n('contact_admin_for_help')}
        <div><strong>{i18n('sectionId')}</strong>: {sectionData._id}</div>
      </p>
    }
  </div>

EditorErrorBoundaryFallback.propTypes =
  sectionData: PropTypes.object.isRequired
  restoreModalState: PropTypes.object.isRequired

module.exports = ConnectStore EditorErrorBoundaryFallback, DocumentSectionsV2Store, storeConnector
